/* eslint-disable no-unused-vars */

import React, {Component} from "react";
import {TextField, withStyles} from "@material-ui/core";
import classNames from 'classnames';

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingTop:'6px',
        paddingBottom:'6px'
    }
});

class InputRow extends Component {
    render() {
        const { classes, children } = this.props;

        return (
            <React.Fragment>
                <div className={classNames('flex', 'w-full', classes.wrapper)}>
                    {children}
                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(InputRow);


// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/InputRow.js